import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './authConfig';

// Initialize MSAL and handle redirect responses with proper initialization
const initializeApp = async () => {
  try {
    // First, initialize MSAL
    await msalInstance.initialize();
    console.log('MSAL initialized successfully');
    
    
    // Then handle redirect responses
    const response = await msalInstance.handleRedirectPromise();
    
    if (response) {
      console.log('Redirect response received:', {
        account: response.account ? 'Present' : 'Missing',
        accessToken: response.accessToken ? 'Present' : 'Missing',
        error: response.error
      });
      
      // Handle successful redirect response
      if (response.account) {
        msalInstance.setActiveAccount(response.account);
      }

      // Restore the URL the user was on before the auth redirect.
      // navigateToLoginRequestUrl is false so MSAL won't do this itself.
      const preAuthUrl = sessionStorage.getItem('msal_pre_auth_url');
      if (preAuthUrl) {
        sessionStorage.removeItem('msal_pre_auth_url');
        window.history.replaceState({}, '', preAuthUrl);
      }
    }
  } catch (error) {
    console.error('Error during MSAL initialization:', error);
    // Even if MSAL initialization fails, we should still render the app
    // The App component will handle the case where instance is not available
  }
  
  // Start the React app
  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </MsalProvider>
  );
};

// Start the app
initializeApp(); 